import { CompanyDto } from './company-dto.model';
import { FsaAppointment } from './fsa-appointment.model';
import { FsaFirmName } from './fsa-firm-name.model';
import { FsaPermission } from './fsa-permission.model';

export class FsaFirm {
  public FirmFsaAppointments: Array<FsaAppointment>;
  public CompanyNames: Array<CompanyDto>;
  public FsaRef: number;
  public Name: string;
  public LegalType?: number;
  public FirmType?: number;
  public ClientMoney: string;
  public Addr1: string;
  public Addr2: string;
  public Addr3: string;
  public Addr4: string;
  public Addr5: string;
  public Addr6: string;
  public PCOut: string;
  public PCIn: string;
  public Tel1: string;
  public Tel2: string;
  public Tel3: string;
  public Fax1: string;
  public Fax2: string;
  public Fax3: string;
  public Status: string;
  public StatusDate?: Date;
  public DateFirstAuth?: Date;
  public SortKey: string;
  public LastUpdated?: Date;
  public FsaFirmNames: Array<FsaFirmName>;
  public FsaPermissions: Array<FsaPermission>;
}
